import { HeaderPage } from "../../../components/header-page/HeaderPage";
import { useNavigate } from "react-router-dom";

export const ProductsHeader = () => {
  const navigate = useNavigate();

  const handleNavigateToProductCategories = () => {
    navigate("categories");
  };

  return (
    <HeaderPage
      title="Products"
      extraActions={[
        {
          label: "Categorías de Productos",
          actionKey: "",
          onClick: handleNavigateToProductCategories,
        },
      ]}
    />
  );
};
